import React from 'react';
import { E1Link } from '@estimateone/frontend-components';
import { QuoteFileAction } from '../../../../enums';

const FilenameOrLink: React.VFC<{
  action: QuoteFileAction;
  file: { fileName: string; downloadUrl?: string };
}> = ({ action, file: { fileName, downloadUrl } }) =>
  action !== QuoteFileAction.Download ? (
    <span>{fileName}</span>
  ) : (
    <E1Link link={downloadUrl} target="_blank" rel="noopener noreferrer">
      {fileName}
    </E1Link>
  );

export default FilenameOrLink;
